module.exports = __webpack_public_path__ + "static/media/pexels-photo-177707.06f9ea59.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/005_mo/pexels-photo-177707.jpeg
// module id = 773
// module chunks = 0